import { useLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useTitle } from '../../../../../common/hooks/useTitle.js';
import { omaElisaForEmployeeMsg, orderRequestsMsg, t } from '../../../../../common/i18n/index.js';
import { EOECustomerOrderDetails } from '../../../../../components/CustomerOrderDetails/EOECustomerOrderDetails';
import type { CustomerOrderLoaderData } from '../../../../../common/loaders';

export const EoePendingReviewPath = () => {
  const { customerOrder, companyInfo, additionalInfo } = useLoaderData() as CustomerOrderLoaderData;

  useTitle([t.H6JV(omaElisaForEmployeeMsg), t.Y29L(orderRequestsMsg), customerOrder?.customerOrderDisplayId ?? '']);

  return (
    <EOECustomerOrderDetails
      pathTemplate={paths.EMPLOYEE_PENDING_REVIEW_ORDER_ITEM}
      ordererContact={additionalInfo?.ordererContact.person}
      customerOrder={customerOrder}
      deviceSubscriptions={additionalInfo?.ordererSubscriptions ?? []}
      breadCrumbPaths={[
        { name: t.H6JV(omaElisaForEmployeeMsg), path: paths.EMPLOYEE_HOME },
        { name: t.Y29L(orderRequestsMsg), path: paths.EMPLOYEE_PENDING_REVIEW_ORDERS },
        { name: customerOrder?.customerOrderDisplayId || '…' },
      ]}
      customerType={companyInfo?.customerType}
      isApprover={true}
    />
  );
};
